import { Typography,Box } from "@mui/material";
import AnnouncementIcon from '@mui/icons-material/Announcement';

export default function NotifyUserAboutPreview() {
    return(
        <Box sx={{display: "flex", paddingTop: {md: 3, xs: 3}, paddingBottom:{xs: 4, md: 0}, gap: 1, }}>
            <AnnouncementIcon color="action" />
            <Typography fontSize={11}  whiteSpace='collapse' sx={{textAlign: "flex-start",}}>
                {/* Please Note:
                The final printed ribbon may differ slightly from the preview shown on the website.
                Variations in color, text placement, and image alignment may occur due to printing limitations, material differences, and screen display settings.
                We do our best to match your design as closely as possible, but slight differences are a normal part of the custom production process. */}
                Please Note:
                The final printed ribbon may differ slightly from the preview in color, image placement, and text alignment due to screen display and printing/material variations.
            </Typography>
        </Box>
        
    )
}